import Future from 'fluture'
import {pipe, keys, contains, map} from 'ramda'
import logout from '@/logout'

const isFuture = (x) => x && typeof x.fork === 'function'

const evolveAction = (action) => (suffix) => (payload) => ({
  ...action,
  payload,
  type: `${action.type}_${suffix}`,
})

export const handleOpenLink = () => (next) => (action) => {
  if (action.type === 'OPEN_LINK') {
    action.payload = Future.cache(action.payload)
    action.payload.fork(
      () => {},
      window.open.bind(window),
    )
  }

  next(action)
}

export const handleOpenLinkHere = () => (next) => (action) => {
  if (action.type === 'OPEN_LINK_HERE') {
    action.payload = Future.cache(action.payload)
    action.payload.fork(
      () => {},
      (url) => window.location.assign(url),
    )
  }

  next(action)
}

export const handleFuture = ({dispatch, getState}) => (next) => (action) => {
  const dispatchAs = evolveAction(action)

  next(action)

  if (isFuture(action.payload)) {
    action.payload.fork(
      pipe(checkIfTokenExpiredAndAddSuffix(dispatchAs, getState, 'FAILURE'), dispatch),
      pipe(checkIfTokenExpiredAndAddSuffix(dispatchAs, getState, 'SUCCESS'), dispatch),
    )
  }
}

export const inject = (deps) => ({getState}) => (next) => (action) =>
  next(
    typeof action === 'function'
      ? action({
        ...deps,
        getState,
      })
      : action
  )

const checkIfTokenExpiredAndAddSuffix = (dispatchAs, getState, suffix) => (data) => {
  // failure scenario
  if (suffix === 'FAILURE') {
    if (isForbidden(data)) {
      logout(window.location, getState().app.user.homeUrl)
    }
  } else {
    // success scenario,
    let failedFutureKeys = []
    const isAnyForbidden = contains(true, map((k) => {
      if (data[k] && typeof data[k] === 'object' && data[k]['future-failure']) { // failed future in sequenceFuturesObject
        failedFutureKeys.push(k)
        return isForbidden(data[k])
      }
    }, keys(data)))
    // add nulls to failure futures
    map((k) => { data[k] = null }, failedFutureKeys)

    if (isAnyForbidden) {
      logout(window.location, (getState().app.user.homeUrl || (data.user && data.user.homeUrl)))
    }
  }
  return dispatchAs(suffix)(data)
}

const isForbidden = (data) => data && data.response && data.response.status === 403



// WEBPACK FOOTER //
// ./src/store/middleware.js